export const USEFUL_LINKS = [
  { label: 'My Account', href: 'https://www.myfoodbag.co.nz/account/' },
  {
    label: 'Blog',
    href: 'https://www.myfoodbag.co.nz/explore/blog/my-food-bag/',
  },
  {
    label: 'Recipes',
    href: 'https://www.myfoodbag.co.nz/explore/recipes/myfoodbag/',
  },
  { label: 'Help Centre', href: 'https://help.myfoodbag.co.nz/hc/en-nz' },
  { label: 'Careers', href: 'https://www.myfoodbag.co.nz/careers' },
  { label: 'Investor Centre', href: 'https://investors.myfoodbag.co.nz/' },
  { label: 'Partnerships', href: 'https://www.myfoodbag.co.nz/b2b-partnerships' },
] as const;

export const SHOP_BASE_URL = 'https://www.myfoodbag.co.nz/shop/explore';
export const SHOP_LINKS = [
  { label: 'About Shop', href: `${SHOP_BASE_URL}/how-it-works` },
  {
    label: 'FAQs',
    href: `${SHOP_BASE_URL}/faq`,
  },
  { label: 'Refund Policy', href: `${SHOP_BASE_URL}/returns` },
  { label: 'Corporate', href: 'https://www.myfoodbag.co.nz/b2b-partnerships' },
] as const;

export const SOCIAL_LINKS = {
  FACEBOOK: 'https://www.facebook.com/MyFoodBagNZ/',
  INSTAGRAM: 'https://www.instagram.com/MyFoodBagNZ',
  LINKEDIN: 'https://www.linkedin.com/company/my-food-bag/',
  YOUTUBE: 'https://www.youtube.com/MyFoodBag',
  X: 'https://twitter.com/MyFoodBagNZ',
} as const;

export const APP_STORE_LINKS = {
  APPLE_STORE: 'https://itunes.apple.com/nz/app/my-food-bag/id1111029382?mt=8We',
  GOOGLE_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.myfoodbag.app',
} as const;

export const MFB_PRIVACY_POLICY_LINK = 'https://www.myfoodbag.co.nz/privacy';
export const MFB_TERMS_CONDITIONS_LINK = 'https://www.myfoodbag.co.nz/terms';
export const MFB_CONTACT_US_LINK = 'https://myfoodbag.zendesk.com';
